<app-link
  class="select-all-link"
  [displayText]="(mode === 'select-all' ? 'common.labels.selectAll' : 'common.labels.selectNone') | translate"
  (click)="clickChange.emit()"
></app-link>
